import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {Button, Modal, Grid} from 'semantic-ui-react';
import headerBorder from '../../assets/images/line-orange.png';
import {Redirect} from 'react-router';
import description from '../../assets/json/destinations/mobile-desc.json';

export default class WorldMap extends Component{

	constructor(props) {
		super(props);
		this.state = {
			europe: description.europe,
			asia: description.asia,
			africa: description.africa,
			australia: description.australia,
			oceania: description.oceania,
			northamerica:description.northamerica,
			southamerica:description.southamerica,
			antarctica:description.antarctica,
			countryname:"",
			countrydesc:"",
			status: "",
			href:"",
			open: false,
			redirect: false,
			routeLink: "",
			continent:[],
			count:"",
			place:""
		}
	}


	handleClose = () => {
		this.setState({ 
			open: false
		});
	}
	
	goToContactUs = () => {
		this.setState({
			redirect: true,
			routeLink: '/contactus'
		});
	}

	onCountryClick = (geography, i) =>{
		this.setState({open: true});
		this.setState({
			countryname: geography.name,
			countrydesc: geography.desc,
			status: geography.status,
			href: geography.href
		});
	}


	render(){
		let {redirect, routeLink, europe, asia, africa, australia, oceania,northamerica, southamerica, antarctica} = this.state;
		return (
			<>
				{ redirect &&
					<Redirect push to={routeLink}/>
				}

				<Modal open={this.state.open} onClose={this.handleClose} size='small' className="modalDestination" closeIcon dimmer='blurring' closeOnDimmerClick={false}>
					<Modal.Header>{this.state.countryname}</Modal.Header>
					<Modal.Content>
						<p className="para-content">
							{this.state.countrydesc}
						</p>
						<p className="para-content para-content-blue">
							{this.state.status}
						</p>
					</Modal.Content>
					<Modal.Actions>
					{this.state.status === "" ?
						<NavLink className="ui orange button" to={this.state.href}>See tour details</NavLink>
					:
						<Button color='orange' onClick={this.goToContactUs} >Contact us</Button>
					}
					
				</Modal.Actions>
				</Modal>
				
				<h2 className="section-header">Europe</h2>
				<img src={headerBorder} className="header-border" alt="" />
				<Grid className="country-list" columns={2}>
					{europe.map((country, i) => (
						<Grid.Column key={i}>
							<p onClick={() => this.onCountryClick(country, i)} className="country-link">{country.name}</p>
						</Grid.Column>
						)
					)}
				</Grid>

				<h2 className="section-header">Asia</h2>
				<img src={headerBorder} className="header-border" alt="" />
				<Grid className="country-list" columns={2}>
					{asia.map((country, i) => (
						<Grid.Column key={i}>
							<p onClick={() => this.onCountryClick(country, i)} className="country-link">{country.name}</p>
						</Grid.Column>
						)
					)}
				</Grid>

				<h2 className="section-header">Africa</h2>
				<img src={headerBorder} className="header-border" alt="" />
				<Grid className="country-list" columns={2}>
					{africa.map((country, i) => (
						<Grid.Column key={i}>
							<p onClick={() => this.onCountryClick(country, i)} className="country-link">{country.name}</p>
						</Grid.Column>
						)
					)}
				</Grid>

				<h2 className="section-header">Australia</h2>
				<img src={headerBorder} className="header-border" alt="" />
				<Grid className="country-list" columns={2}>
					{australia.map((country, i) => (
						<Grid.Column key={i}>
							<p onClick={() => this.onCountryClick(country, i)} className="country-link">{country.name}</p>
						</Grid.Column>
						)
					)}
				</Grid>

				<h2 className="section-header">Oceania</h2>
				<img src={headerBorder} className="header-border" alt="" />
				<Grid className="country-list" columns={2}>
					{oceania.map((country, i) => (
						<Grid.Column key={i}>
							<p onClick={() => this.onCountryClick(country, i)} className="country-link">{country.name}</p>
						</Grid.Column>
						)
					)}
				</Grid>

				<h2 className="section-header">North America</h2>
				<img src={headerBorder} className="header-border" alt="" />
				<Grid className="country-list" columns={2}>
					{northamerica.map((country, i) => (
						<Grid.Column key={i}>
							<p onClick={() => this.onCountryClick(country, i)} className="country-link">{country.name}</p>
						</Grid.Column>
						)
					)}
				</Grid>

				<h2 className="section-header">South America</h2>
				<img src={headerBorder} className="header-border" alt="" />
				<Grid className="country-list" columns={2}>
					{southamerica.map((country, i) => (
						<Grid.Column key={i}>
							<p onClick={() => this.onCountryClick(country, i)} className="country-link">{country.name}</p>
						</Grid.Column>
						)
					)}
				</Grid>

				<h2 className="section-header">Antarctica</h2>
				<img src={headerBorder} className="header-border" alt="" />
				<Grid className="country-list" columns={2}>
					{antarctica.map((country, i) => (
						<Grid.Column key={i}>
							<p onClick={() => this.onCountryClick(country, i)} className="country-link">{country.name}</p>
						</Grid.Column>
						)
					)}
				</Grid>
			</>
		);
	}
}
